import { Benefit } from "../models/Benefit";

const BenefitComponent = ({ benefit }: { benefit: Benefit }) => {
  const poppinsFont = {
    fontFamily: "Poppins",
  };

  return (
    <div className="flex mb-5">
      <div className="w-1/5">
        <img className="w-full" loading="lazy" src={benefit.icon} alt={benefit.header} />
      </div>
      <div className="w-4/5" style={poppinsFont}>
        <h3 className="font-medium text-2xl">{benefit.header}</h3>
        <p className="font-light ml-2">{benefit.description}</p>
      </div>
    </div>
  );
};

export default BenefitComponent;
